// Design tokens for the MATS Console redesign (redesign/README.md).
// Single source of truth for the colours, families and layout constants
// referenced by the mats ui-components and the redesigned views.

export const mats = {
  // surfaces
  surfaceApp: '#faf9f7',
  surfacePanel: '#ffffff',
  surfaceSunken: '#f2f1ed',
  surfaceAccentTint: '#f7f2ec',
  surfaceRowSelected: '#fbf8f4',

  // borders
  borderHairline: '#efece6',
  borderDefault: '#e6e2db',
  borderStrong: '#ddd9d2',
  chipBorder: '#e0dcd4',

  // text
  textPrimary: '#1c1b19',
  textSecondary: '#4a463f',
  textMuted: '#7a766f',
  textFaint: '#8a857c',
  textPlaceholder: '#a09a90',

  // accent — action only (buttons, active nav, active tab, focus)
  accentPrimary: '#cf6112',
  accentPrimaryHover: '#b95709',
  accentOnTint: '#a8500d',

  // state — order and enablement state only
  positive: '#2f7a5e',
  positiveBg: '#eaf3ef',
  positiveBorder: '#c5ded3',
  positiveText: '#1f5c47',
  negative: '#a34a52',
  info: '#2f5fb8',

  // inverse (tertiary dark button)
  inverseSurface: '#1c1b19',
  inverseText: '#faf9f7',

  // typography
  fontUi: `'Libre Franklin', 'Inter', 'Helvetica Neue', Arial, sans-serif`,
  fontMono: `'JetBrains Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', monospace`,

  // layout
  sidebarWidth: 204,
  sidebarRailWidth: 60,
  drawerWidth: 340,
  gutter: 26
};

// Shared text styles
export const matsType = {
  pageTitle: { fontFamily: mats.fontUi, fontSize: '22px', fontWeight: 600, letterSpacing: '-0.02em', color: mats.textPrimary },
  pageSubtitle: { fontFamily: mats.fontUi, fontSize: '13.5px', fontWeight: 400, color: mats.textMuted },
  sectionTitle: { fontFamily: mats.fontUi, fontSize: '14px', fontWeight: 600, color: mats.textPrimary },
  panelTitle: { fontFamily: mats.fontUi, fontSize: '16px', fontWeight: 600, letterSpacing: '-0.01em', color: mats.textPrimary },
  columnHeader: {
    fontFamily: mats.fontMono,
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: mats.textPlaceholder
  },
  groupHeader: {
    fontFamily: mats.fontMono,
    fontSize: '9.5px',
    fontWeight: 400,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: mats.textFaint
  },
  eyebrow: {
    fontFamily: mats.fontMono,
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '0.11em',
    textTransform: 'uppercase',
    color: mats.textPlaceholder
  },
  cellPrimary: { fontFamily: mats.fontUi, fontSize: '13.5px', fontWeight: 500, color: mats.textPrimary },
  cellSecondary: { fontFamily: mats.fontUi, fontSize: '13px', fontWeight: 400, color: mats.textSecondary },
  cellNumeric: {
    fontFamily: mats.fontMono,
    fontSize: '12.5px',
    fontWeight: 400,
    fontVariantNumeric: 'tabular-nums',
    color: mats.textPrimary
  },
  fieldLabel: { fontFamily: mats.fontUi, fontSize: '11.5px', fontWeight: 400, color: mats.textMuted },
  footerMeta: { fontFamily: mats.fontUi, fontSize: '12.5px', fontWeight: 400, color: mats.textFaint }
};

export default mats;
